<div class="">
    <div class="fixed lg:static top-[64px] inset-x-0 bg-gray-100 p-2 z-40 lg:pr-40 lg:pl-8 rtl:lg:pr-7 rtl:lg:pl-20
          lg:top-auto
          animate-slide-down">
      <div class="flex items-center justify-between">
          <!-- Progress -->
          <div>
            <div class="flex gap-5 items-center">
              <img src="/icons/svg/success.svg" />
              <div>
                <h3 class="text-2xl font-semibold text-dc-navy">
                  {{ "SUCCESS_PAGE.APPLICATION_SUCCESSFULL" | translate }}
                </h3>

                @if (false) {
                <div class="flex items-center gap-2 mt-1 text-sm text-gray-700">
                  <span class="text-dc-navy">
                    {{ "COMPLETE" | translate : { percent: formProgress } }}</span
                  >
                  <div class="w-28 h-2 bg-gray-300 rounded overflow-hidden">
                    <div
                      class="bg-dc-blue h-full"
                      [ngStyle]="{ width: formProgress + '%' }"
                    ></div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>

          <!--Chat Button -->
          <!-- <button
            class="flex items-center gap-2 bg-white px-4 py-2 hover:bg-gray-100"
          >
            <img src="/icons/svg/chat.svg" />
            <span class="text-dc-navy font-medium hidden lg:inline">{{
              "CHAT_WITH_US" | translate
            }}</span>
          </button> -->
      </div>
    </div>

  <div class="bg-white form-bg-pattern pt-16 lg:pt-0">
   <div class="form-card ">
      <!-- skeleton -->
      @if (loader) {
        <app-skeleton-loader></app-skeleton-loader>     
      }
      @else {
        <section class="px-2">
          <div>
            <!-- <div class="mb-6 success-ref-title">
                 <span [innerHTML]="'SUCCESS_PAGE.REF_NUMBER' | translate : { ref: srDetails ? srDetails['SR Number'] : '' }"></span>
            </div> -->

            <!-- system messages -->
            <div class="text-dc-black text-sm">
               @if(srDetails["SR Sub Type"] == serviceName.INFORMATION_SERVICES
               || srDetails["SR Sub Type"] == serviceName.MEDIATION
               || srDetails["SR Type"] == serviceName.COO
               || srDetails["SR Type"] == serviceName.SERVICE_EXCELLENCE_PROGRAMME
               || srDetails["SR Type"] == serviceName.MRM_AWARDS
               ){
                <span class="inline-block w-full">{{ "SUCCESS_PAGE.EMAIL_SENT" | translate }}</span>
               }
              
              @if(srDetails["SR Type"] == serviceName.MEMBERSHIP){
                @if(srDetails["SR Sub Type"] == serviceName.MEMBERSHIP_NEW){
                  {{ "SUCCESS_PAGE.MEMBERSHIP_NEW_SUBMIT" | translate }}
                }
                 @if(srDetails["SR Sub Type"] == serviceName.MEMBERSHIP_AMENDMENT){
                  {{ "SUCCESS_PAGE.MEMBERSHIP_AMENDMENT_SUBMIT" | translate }}
                }
                 @if(srDetails["SR Sub Type"] == serviceName.MEMBERSHIP_RENEW){
                  {{ "SUCCESS_PAGE.MEMBERSHIP_RENEW_SUBMIT" | translate }}
                }
                 @if(srDetails["SR Sub Type"] == serviceName.MEMBERSHIP_CANCELLATION){
                  {{ "SUCCESS_PAGE.MEMBERSHIP_CANCELLATION_SUBMIT" | translate }}
                }             
              } 
              
              @if(srDetails["SR Sub Type"] == serviceName.INFORMATION_SERVICES){
                @if( srDetails["FS Charge Web"]["DC Product Type Portal"] == fieldValue.COMPANY_PROFILE){
                  {{ "SUCCESS_PAGE.INFO_SERVICE_SR_SUBMIT_CP" | translate }}
                }@else{
                  {{ "SUCCESS_PAGE.INFO_SERVICE_SR_SUBMIT" | translate }}
                } 
              } 
              @if(srDetails["SR Sub Type"] == serviceName.MEDIATION || 
              srDetails["Sub Type"] == serviceName.MYSTERY_SHOPPER_MEMBERSHIP
              ){
                {{ "SUCCESS_PAGE.MEDIATION_SR_SUBMIT" | translate }}
              } 

              @if(srDetails["SR Sub Type"] == serviceName.MRM_APPLICATION 
               || srDetails["SR Sub Type"] == serviceName.MRM_TRAINING_WORKSHOP){
                 {{ "SUCCESS_PAGE.MRM_AWARDS_SR_SUBMIT" | translate }}
              }

              @if(srDetails["SR Sub Type"] == serviceName.ATTESTATION_AUTH_CERTIFICATE || srDetails["SR Sub Type"]
              == serviceName.ATTESTATION_VERIFY_SIGNATURE){
                {{ "SUCCESS_PAGE.ATTEST_SERVICE_SR_SUBMIT" | translate }}
              } 
              @if(srDetails["SR Sub Type"] ==  serviceName.ATTESTATION_CERTIFY_DOCUMENT){
                {{ "SUCCESS_PAGE.ATTEST_SERVICE_CERTIFIY_SR_SUBMIT" | translate }}
              }

              @if(srDetails["Sub Type"] == serviceName.ISSUE_NEW_CARNET){
                <span [innerHTML]="'SUCCESS_PAGE.ATA_ISSUE_CARNET_SR_SUBMIT' | translate : {ataEmail:loginUserEmail} "></span>
              }

              @if(srDetails["Sub Type"] == serviceName.AMENDMENT_CARNET){
                <span class="inline-block w-full" [innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_SR_SUBMIT' | translate : {days:1}"></span>
                <span class="inline-block w-full text-dc-black font-semibold text-lg" [innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_Fees' | translate "></span>
                <span class="inline-block w-full text-dc-navy text-lg font-semibold"[innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_AMOUNT' | translate :{ ATA_AmendmentAmount: ataAmendmentAmount | currency} "></span>
                <span class="inline-block mt-2 w-full py-2" [innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_FEES_NOTE' | translate "></span>
                <span class="inline-block mt-2 w-full py-2" [innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_NOTE' | translate "></span>
              }

              @if(srDetails["Sub Type"] == serviceName.REPLACE_CARNET || srDetails["Sub Type"] == serviceName.SUBSTITUTE_CARNET){
                <span class="inline-block w-full" [innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_SR_SUBMIT' | translate : {days:1}"></span>
                <span class="inline-block pt-2 w-full py-2 text-dc-black font-semibold text-lg" [innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_Fees' | translate "></span>
                <span class="inline-block w-full text-dc-navy font-semibold"[innerHTML]="'SUCCESS_PAGE.ATA_REPLACEMENT_CARNET_NORMAL_AMOUNT' | translate : {amount:900 | currency}"></span>
                <span class="inline-block w-full text-dc-navy font-semibold"[innerHTML]="'SUCCESS_PAGE.ATA_REPLACEMENT_CARNET_EXPRESS_AMOUNT' | translate : {amount:1800 | currency}"></span>
                <span class="inline-block mt-2 w-full py-2" [innerHTML]="'SUCCESS_PAGE.ATA_AMENDMENT_CARNET_NOTE' | translate "></span>
              }

               @if(srDetails["Sub Type"] == serviceName.REFUND_CARNET){
                <span class="inline-block w-full py-2" [innerHTML]="'SUCCESS_PAGE.ATA_REFUND_DELIVER_CARNET' | translate : {days:1}"></span>
                <span class="inline-block w-full py-2" [innerHTML]="'SUCCESS_PAGE.ATA_REFUND_TEAM_REVIEW' | translate "></span>
                <span class="inline-block w-full py-2" [innerHTML]="'SUCCESS_PAGE.ATA_REFUND_PROCESS' | translate "></span>
              }

              
               @if(srDetails["Sub Type"] == serviceName.NOC_LETTER_CARNET){
                <span class="inline-block w-full" [innerHTML]="'SUCCESS_PAGE.NOC_LETTER_RECEIVED' | translate"></span>
                <span class="inline-block w-full" [innerHTML]="'SUCCESS_PAGE.NOC_LETTER_WHATS_NEXT_TITLE' | translate "></span>
                <span class="inline-block mt-2 w-full py-2" [innerHTML]="'SUCCESS_PAGE.NOC_LETTER_SR_SUBMIT' | translate "></span>
                <span class="inline-block w-full text-dc-black font-semibold text-lg" [innerHTML]="'SUCCESS_PAGE.NOC_LETTER_FEES_TITLE' | translate "></span>
                <span class="inline-block w-full text-dc-navy font-semibold" [innerHTML]="'SUCCESS_PAGE.NOC_LETTER_FEES_AMOUNT' | translate :{amount:100 | currency}"></span>
                <span class="inline-block mt-2 w-full py-2" [innerHTML]="'SUCCESS_PAGE.NOC_LETTER_STATUS_NOTE' | translate "></span>
              }
              @if(srDetails["SR Sub Type"] == serviceName.ISSUE_NEW_COO
              || srDetails["SR Sub Type"] == serviceName.AMENDMENT_COO
              || srDetails["SR Sub Type"] == serviceName.PERSONAL_EFFECTS_COO
              || srDetails["SR Sub Type"] == serviceName.ISSUE_GSP_COO){
                <span class="inline-block w-full" [innerHTML]="'SUCCESS_PAGE.COO_ISSUE' | translate : {days:7}"></span>
              }
              @if(srDetails["SR Sub Type"] == serviceName.USER_ACCESS){
                <span class="inline-block w-full" [innerHTML]="'SUCCESS_PAGE.ADD_MORE_BUSINESS' | translate : {days:7}"></span>
              }

              @if(srDetails["SR Sub Type"] == serviceName.CHAMBER_ENTREPRENEURS){
                <span class="inline-block w-full" [innerHTML]="'SUCCESS_PAGE.ENTREPRENEURSHIP_THANK' | translate"></span>
                <span class="inline-block pt-2 w-full py-2" [innerHTML]="'SUCCESS_PAGE.ENTREPRENEURSHIP_NATIONALS' | translate"></span>
                <span class="inline-block pt-2 w-full py-2" [innerHTML]="'SUCCESS_PAGE.ENTREPRENEURSHIP_FORWARD' | translate"></span>
              }
            </div>

           
            <!-- details table --------------------------------------------------->
            <div class="text-dc-black text-sm mt-5">
              @if(srDetails["SR Type"] == serviceName.MEMBERSHIP){
               {{ "SUCCESS_PAGE.MEMBERSHIP_DETAILS" | translate }}
              }@else {
                @if(srDetails["SR Sub Type"] != serviceName.CHAMBER_ENTREPRENEURS){
                  {{ "SUCCESS_PAGE.APPLICATION_DETAILS" | translate }}
                }
              }
            </div>
            <div class="mt-5 mb-5 space-y-4">
              <!-- <table class="w-full border-t text-sm"> -->
                <table class="w-full border-t text-sm success-details-table">
                <tbody>
                  @if(srDetails["SR Type"] == serviceName.MEMBERSHIP && srDetails["DC Member Name(English)"]){
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.COMPANY_NAME" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                        {{ srDetails ? srDetails["DC Member Name(English)"] : "" }}
                      </td>
                    </tr>
                  } 
                  
                  @if(srDetails["SR Sub Type"] ==
                  serviceName.ATTESTATION_AUTH_CERTIFICATE || srDetails["SR Sub Type"] == serviceName.ATTESTATION_CERTIFY_DOCUMENT ||
                  srDetails["SR Sub Type"] ==
                  serviceName.ATTESTATION_VERIFY_SIGNATURE || srDetails["SR Type"] ==
                  serviceName.COO){
                  @if(srDetails["DC Member Name (English)"]){
                  <tr class="border-b">
                    <td class="py-2 text-dc-black">
                      {{ "SUCCESS_PAGE.COMPANY_NAME" | translate }}
                    </td>
                    <td class="py-2 text-dc-navy font-semibold">
                      <!-- {{ companyName }} -->
                        {{srDetails["DC Member Name (English)"]}}
                    </td>
                  </tr>
                  }

                  <tr class="border-b">
                    <td class="py-2 text-dc-black">
                      {{ "SUCCESS_PAGE.ATTEST_APPLICATION_TYPE" | translate }}
                    </td>
                    <td class="py-2 text-dc-navy font-semibold">
                      {{ srDetails ? getSRTypeValue(srDetails["SR Type"], srDetails["SR Sub Type"]) : "" }}
                    </td>
                  </tr>
                  }
                  <!-- <tr class="border-b">
                    <td class="py-2 text-dc-black">
                      {{ "SUCCESS_PAGE.MEMBERSHIP_NUMBER" | translate }}
                    </td>
                    <td class="py-2 text-dc-navy font-semibold">-</td>
                  </tr> -->
                  @if(srDetails && srDetails["DC Cancel Reason"]){
                  <tr class="border-b">
                    <td class="py-2 text-dc-black">
                      {{ "SUCCESS_PAGE.MEMBERSHIP_CANCELLATION_REASON" | translate }}
                    </td>
                    <td class="py-2 text-dc-navy font-semibold">
                      {{ srDetails ? srDetails["DC Cancel Reason"] : "-" }}
                    </td>
                  </tr>
                  } 
                   @if(srDetails && srDetails["Membership Years"]){
                  <tr class="border-b">
                    <td class="py-2 text-dc-black">
                      {{ "SUCCESS_PAGE.MEMBERSHIP_YEARS" | translate }}
                    </td>
                    <td class="py-2 text-dc-navy font-semibold">
                      {{ srDetails ? srDetails["Membership Years"] : "-" }}
                    </td>
                  </tr>
                  } 
                  @if(srDetails){ 
                    @if((srDetails["SR Type"] == serviceName.MEMBERSHIP || srDetails["SR Type"] == serviceName.INFORMATION_SERVICES || srDetails["SR Type"] == serviceName.MEDIATION_SERVICES) && srDetails["DC Amount New"] && srDetails["DC Amount New"] !="0"){
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.PAYMENT_AMOUNT" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                         <span class='currency-amount'>
                          <span class='currency-icon currency-icon-aed'></span>
                          {{ srDetails ? srDetails["DC Amount New"] : "-" }}
                        </span>
                        
                      </td>
                    </tr>
                    } 
                    @if( this.srDetails && this.srDetails['DC Receipt Amount'] && this.srDetails['DC Receipt Amount'] != "0"){
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.PAYMENT_AMOUNT" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                         <span class='currency-amount'>
                          <span class='currency-icon currency-icon-aed'></span>
                          {{ this.srDetails['DC Receipt Amount'] }}
                        </span>                        
                      </td>
                    </tr>
                    }
                     @if(srDetails["SR Type"] == serviceName.COO && this.srDetails['DCTotalFees']){
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.PAYMENT_AMOUNT" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                         <span class='currency-amount'>
                          <span class='currency-icon currency-icon-aed'></span>
                          {{ this.srDetails['DCTotalFees'] }}
                        </span>                        
                      </td>
                    </tr>
                    }                    
                    @if(srDetails["SR Sub Type"] ==
                    serviceName.INFORMATION_SERVICES){
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.INFO_SERVICE_REQ_LETTER" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                        {{ productType }}
                      </td>
                    </tr>
                    }
                    @if(srDetails["SR Sub Type"] == serviceName.MEDIATION){
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.MEDIATION_DISPUTE_TYPE" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                        {{ srDetails["DC Nature Of Dispute"] }}
                      </td>
                    </tr>

                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.MEDIATION_DEFAULTER_COMPANY" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                        {{ srDetails["DC Respondant Name"] }}
                      </td>
                    </tr>
                    }

                    @if(srDetails["Sub Type"] == serviceName.ISSUE_NEW_CARNET ||
                      srDetails["Sub Type"] == serviceName.MYSTERY_SHOPPER_MEMBERSHIP||
                      srDetails["Sub Type"] == serviceName.MRM_APPLICATION ||
                      srDetails["Sub Type"] == serviceName.MRM_TRAINING_WORKSHOP){
                        <tr class="border-b">
                          <td class="py-2 text-dc-black">
                            {{ "SUCCESS_PAGE.SERVICE_NAME" | translate }}
                          </td>
                          <td class="py-2 text-dc-navy font-semibold">
                            {{ srDetails ? srDetails["Sub Type"] : "" }}
                          </td>
                        </tr>
                    }
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.SR_STATUS" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                        {{ srDetails ? srDetails["Status"] : "" }}
                      </td>
                    </tr>
                    <tr class="border-b">
                      <td class="py-2 text-dc-black">
                        {{ "SUCCESS_PAGE.REFERENCE_NUMBER_IS" | translate }}
                      </td>
                      <td class="py-2 text-dc-navy font-semibold">
                          {{srDetails ? srDetails['SR Number'] : ''}}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <!-- actions -->

            <div class="flex flex-col sm:flex-row sm:flex-wrap gap-4 py-4">
              @if (srDetails["Status"] == srStatus.Approved) {
              <!-- <app-button
                [type]="'button'"
                [label]="'BUTTONS.PREVIEW_CERTIFICATE' | translate"
                classesName="card-edge-cut-white"
                (onBtnClick)="(false)"
              /> -->

              <!-- <app-button
                [type]="'button'"
                [label]="'BUTTONS.DOWNLOAD_CERTIFICATE' | translate"
                classesName="btn-edge-cut"
                (onBtnClick)="(false)"
              /> -->
              <!-- <app-button
                        [type]="'button'"
                        [label]="'BUTTONS.DOWNLOAD_INVOICE' | translate"
                        classesName="card-edge-cut-white"
                        (onBtnClick)="(false)"
                        /> -->
              <app-button
                class="block w-full sm:w-auto"
                [type]="'button'"
                [label]="'BUTTONS.GO_TO_DASHBOARD' | translate"
                classesName="card-edge-cut-white btn-primary-big w-full sm:w-auto"
                (onBtnClick)="gotoDashboard()"
              />
              }@else {
                 <app-button
                class="block w-full sm:w-auto"
                [type]="'button'"
                [label]="'BUTTONS.ADD_NOTES' | translate"
                classesName="btn-edge-cut btn-primary-big w-full sm:w-auto"
                (onBtnClick)="showNotes=true"
              />
              <app-button
                class="block w-full sm:w-auto"
                [type]="'button'"
                [label]="'BUTTONS.GO_TO_DASHBOARD' | translate"
                classesName="card-edge-cut-white btn-primary-big w-full sm:w-auto"
                (onBtnClick)="gotoDashboard()"
              />
              }
            </div>

              <!-- company notice -->
              @if(srDetails["SR Sub Type"] != serviceName.MEMBERSHIP_NEW){
                <div class="py-4">
                  <app-company-info-notice
                    [companyInfoLoading]="companyInfoLoading"
                    [isCompanyInformationCompleted]="isCompanyInformationCompleted"
                    (onBtnClick)="gotoCompanyInfo()"
                  ></app-company-info-notice>
                </div>
              }

            <!-- callout card -->
            <!-- @if(srDetails["SR Sub Type"] == serviceName.MEMBERSHIP_NEW ){
            <app-validation-message
              color="gray"
              [content]="{
                title: 'SUCCESS_PAGE.ADD_MORE_USERS_TITLE' | translate,
                message: 'SUCCESS_PAGE.ADD_MORE_USERS_DESC' | translate
              }"
              [showbutton]="true"
              [buttonText]="'SUCCESS_PAGE.ADD_MORE_USERS_CTA' | translate"
              (onBtnClick)="(false)"
            />
            } -->

            @if(srDetails["SR Sub Type"] == serviceName.ISSUE_NEW_COO ){
            <app-validation-message
              type="info"
              [content]="{
                title: 'SUCCESS_PAGE.COO_ISSUE_INFO_TITLE' | translate,
                message: 'SUCCESS_PAGE.COO_ISSUE_INFO_DESC' | translate
              }"
              [showbutton]="false"
              [buttonText]="'SUCCESS_PAGE.COO_ISSUE_INFO_COPY' | translate"
              [startNewText]="'SUCCESS_PAGE.COO_ISSUE_INFO_NEW' | translate"
              (onBtnClick)="createCopy($event)"
            />
            }
          </div>
        </section>


        <!-- other services -->
        @if(srDetails["SR Sub Type"] != serviceName.MEMBERSHIP_NEW && srDetails["SR Sub Type"] != serviceName.CHAMBER_ENTREPRENEURS && userCSN){
         <section class="lg:max-w-[80%]">
          <h1 class="section-heading">
            {{ "SUCCESS_PAGE.SUGGESTED_SERVICES" | translate }}
          </h1>

          <div class="grid gap-6 md:grid-cols-2 px-2 auto-rows-fr">
            @for (service of suggestedServices; track service) {
              <div class="h-full">
                <div class="border-blue relative card-edge-cut h-full flex flex-col">
                  <div class="card-body flex flex-col h-full">
                    <h3 class="text-lg font-semibold">
                      {{ service.serviceName | translate }}
                    </h3>

                    <div class="mt-auto pt-4">
                      <a
                        class="inline-flex items-center gap-2 font-semibold"
                        [routerLink]="['/' + service.path]"
                      >
                        {{ "SUCCESS_PAGE.START_SERVICE" | translate }}
                        <!-- <i class="fas fa-arrow-right rtl:rotate-180"></i> -->
                        <img src="/icons/svg/arrow-right.svg" class="rtl:rotate-180">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </section>
        }
      }
      
    </div>
  </div>
</div>

@if(showHappinessMeter && happinessUrl){
<div class="dc-modal">
  <div class="dc-modal-container">
     <button
      class="modal-x-button"
      type="button"
      (click)="showHappinessMeter = false"
    >
      <i class="fas fa-close"></i>
      </button>
      <div class="p-5">
        <iframe
          width="100%"
          [src]="happinessUrl"
          frameborder="0"
          height="450"
        ></iframe>
      </div>
  </div>
</div>
}

@if(showNotes) {
  <app-notes [srNumber]="srNumber" (onClose)="closeNotes($event)"></app-notes>
}
